import get from 'lodash/get';
import { createSelector } from 'reselect';
import { getEntitySelector } from '../selectors';
import { ENTITIES_KEY_FORM, FORM_TYPE_TICKET_SALE, FORM_TYPE_TICKET_SELECTION, FORM_TYPE_RSVP } from './index';

/**
 * ⚠️ This returns all entities, including orphan ones.
 * @param  {Object} state
 * @param  {string} formId
 * @return {Object}
 */
export const getForm = (state, formId) => getEntitySelector(state, ENTITIES_KEY_FORM)[formId];

/**
 * @param  {Object} state
 * @return {Object}
 */
export const getAllForms = (state) => Object.values(getEntitySelector(state, ENTITIES_KEY_FORM));

/**
 * @param {Object} state
 * @param {string} formId
 * @return {string|undefined}
 */
export const getFormLabel = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'label');
};

/**
 * @param {Object} state
 * @param {string} formId
 * @return {string|undefined}
 */
export const getFormType = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'type');
};

export const getFormVersion = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'version');
};

export const getCached = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'cached');
};

export const isFormTypeTicketSale = createSelector(getFormType, (formType) => formType === FORM_TYPE_TICKET_SALE);

export const isFormTypeTicketSelection = createSelector(
    getFormType,
    (formType) => formType === FORM_TYPE_TICKET_SELECTION,
);

export const isFormTypeRsvp = createSelector(getFormType, (formType) => formType === FORM_TYPE_RSVP);

/**
 * @param {Object} state
 * @param {string} formId
 * @return {string}
 */
export const getSubmitButtonLabel = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'submitButtonLabel', '');
};

export const getRootNodeId = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'root', null);
};

export const getErrorMessages = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'errorMessages', {});
};

export const getErrorMessage = (state, formId, errorKey) => {
    const form = getForm(state, formId);
    return get(form, `errorMessages.${errorKey}`, '');
};

export const getStyleConfiguration = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'styleConfiguration', {});
};

export const getFormLibraryFormName = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'formLibraryForm.name');
};

export const getFormLibraryFormId = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'formLibraryForm.formLibraryFormId');
};

export const getEntitiesFormLibrary = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'formLibraryForm');
};

export const getEventFormData = (state, formId) => {
    const form = getForm(state, formId);
    return get(form, 'eventForm');
};
